import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from './images/main-logo.png';
import indflag from './images/ind-flag.png';
import uaeflag from './images/uae-flag.png';
import globalicon from './images/main-world.png';
import menu from './images/menu-02.png';
import './css/app1.css';
import Popup from './Popup';
import SubFooter from '../../Footer/components/SubFooter';
import Mega_Menu from '../../Footer/components/Mega_Menu';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary abbas">
      <div className="container-fluid" id="main1">
        <div className="col-md-2">
          <Link className="navbar-brand" id="main-logo" to="/">
            <img src={logo} width="50" height="50" alt="Logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <div className="col-md-6">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 ab">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/about">
                  About-us
                </Link>
              </li>
              <li className="nav-item">
                <div className="btn-group">
                  <Link className="nav-link active" to="/services">
                    Services
                  </Link>
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  ></button>
                  <ul className="dropdown-menu">
                    <li>
                      <Link className="nav-link active dropdown-item" to="/services/ads-management">
                        Ads Management
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-link active dropdown-item" to="/services/content-writing">
                        Content Writing
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-link active dropdown-item" to="/services/graphic-design">
                        Graphic Design
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-link active dropdown-item" to="/services/seo">
                        SEO
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-link active dropdown-item" to="/services/social-media">
                        Social Media
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-link active dropdown-item" to="/services/ui-ux">
                        UI / UX Design
                      </Link>
                    </li>
                    <li>
                      <Link className="nav-link active dropdown-item" to="/services/website-development">
                        Website Services
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">
                  Portfolio
                </Link>
              </li> */}
              {/* <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/privacy-policy">
                  Privacy Policy
                </Link>
              </li> */}
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/contact-us">
                  Contact-us
                </Link>
              </li>
            </ul>
          </div>
          <div className="leftsidenav col-md-4">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 ac">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="https://wa.link/yecthx">
                  <u>+971-50854-5971</u>
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">
                  <u>Speak to us</u>
                </Link>
              </li> */}
              <li className="nav-item">
                <Link className="navbar-brand" to="/">
                  <img src={indflag} width="20" height="auto" alt="IN Flag" />
                </Link>
              </li>
              <li className="nav-item">
                <Link className="navbar-brand" to="/">
                  <img src={uaeflag} width="20" height="auto" alt="UAE Flag" />
                </Link>
              </li>
              <li className="nav-item">
                <Link className="navbar-brand" to="/">
                  <img src={globalicon} width="20" height="auto" alt="Global" />
                </Link>
              </li>
              {/* <li className="nav-item">
                <img
                  src={menu}
                  width="20"
                  margin-right="5px"
                  height="auto"
                  alt="Menu"
                  onClick={togglePopup}
                  style={{ cursor: "pointer" }}
                />
                {isOpen && (
                  <Popup
                    
                    content={<Mega_Menu/>}
                    handleClose={togglePopup}
                  />
                )}
              </li> */}
              
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
